module.exports = __webpack_public_path__ + "static/media/_facility-card.c2fec97b.scss";


//////////////////
// WEBPACK FOOTER
// ./src/styles/components/_facility-card.scss
// module id = 667
// module chunks = 0